<div class="one" [formGroup]="SettingForm" fxLayout="column">
  <div fxLayout="row wrap" fxLayoutAlign="start stretch" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="silq-imput full-width mt-4 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.APLYIDKEY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.APLYIDKEY),
      }"
    >
      <mat-label>API Key</mat-label>
      <input class="sideText wrap-text text-left" matInput formControlName="APLYIDKEY" />
    </mat-form-field>

    @if (!hasAplyIdKey && !isRequestSent) {
      <div class="request-aplyid-container">
        <button
          mat-raised-button
          color="primary"
          (click)="requestAplyIdAccount()"
          [disabled]="isLoading"
        >
          @if (isLoading) {
            <mat-spinner diameter="18" class="mr-2"></mat-spinner>
          }
          Request AplyId Access
        </button>
      </div>
    }

    @if (isRequestSent) {
      <div class="aplyid-success full-width">
        <mat-icon color="primary">check_circle</mat-icon>
        <span class="success-text">
          Your request to create an account with AplyId has been received.
          <br />
          You will need to complete the form at
          <a
            href="https://registration.aplyid.com/forms/DVS-AUEntity?name=Silq"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://registration.aplyid.com/forms/DVS-AUEntity?name=Silq
          </a>
          before the application can proceed.
          <br />
          Please check back later to confirm that it has been successfully processed.
        </span>
      </div>
    }

    <mat-form-field
      appearance="outline"
      class="silq-imput full-width mt-4 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.APLYIDSECRET),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.APLYIDSECRET),
      }"
    >
      <mat-label>API Secret Key</mat-label>
      <input class="sideText wrap-text text-left" matInput formControlName="APLYIDSECRET" />
    </mat-form-field>

    <div class="open_knowledge_btn">
      <button matButton="filled" class="btn_2">
        <a
          href="https://community.silq.com.au/en/configure-your-aml-integration"
          target="_blank"
          rel="noopener noreferrer"
          style="color: white; text-decoration: none"
        >
          Open Knowledge Base for more information on completing the form
        </a>
      </button>
    </div>
  </div>
</div>
